module.exports = function() {
	return new Worker(__webpack_public_path__ + "ba4a87fe461549c80b65.contact-us.wrkr.js");
};